import { FC } from 'react';
import { InfoModalProps, InfoTranslationsVariant, useInfoTranslations } from '../model';
import { ModalLayout, ModalLayoutVariant } from '../../modalLayout';
import { ButtonsPanel } from '../../buttonsPanel';
import { Button } from '../../button';
import { Typography } from '../../typography';

export const InfoModal: FC<InfoModalProps> = ({ onClose, translations }) => {
  const translation = useInfoTranslations(translations);
  return (
    <ModalLayout
      containerSx={{
        textAlign: 'center',
        px: 1,
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      onClose={onClose}
      variant={ModalLayoutVariant.drawerRight}
    >
      {translation(InfoTranslationsVariant.title, ({ value }) => (
        <Typography component="div" sx={{ mb: 3.9 }} variant="h1">
          {value}
        </Typography>
      ))}

      {translation(InfoTranslationsVariant.info, ({ value }) => (
        <Typography variant="body">{value}</Typography>
      ))}

      {translation(InfoTranslationsVariant.btn, ({ value }) => (
        <ButtonsPanel sx={{ position: 'absolute', bottom: 0, left: 0, width: 1, px: 1 }}>
          <Button onClick={onClose} sx={{ width: 1 }} type="button">
            {value}
          </Button>
        </ButtonsPanel>
      ))}
    </ModalLayout>
  );
};
